import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { LinkButton } from '../Input/Button/LinkButton';
import { Button } from '../Input/Button/Button';

type StatusItem = {
  label: React.ReactNode;
  className?: string;
  complete: boolean;
  hide?: boolean;
} & (
  | {
      // each item can either be a button or a link
      onClick?: () => void;
      to?: void;
    }
  | {
      onClick?: undefined;
      to?: string;
    }
);

interface Props {
  items: StatusItem[];
}

export const StatusList: FunctionComponent<Props> = ({ items }) => {
  let firstIncomplete = items.findIndex((item) => !item.complete);
  if (firstIncomplete === -1) {
    firstIncomplete = items.length;
  }

  const renderItemContent = (item: StatusItem, index: number) => (
    <>
      <div className={styles.stepVisuals}>
        {/* Render the checkbox circle */}
        <div
          className={classNames(
            styles.stepButton,
            firstIncomplete === index && styles.stepButtonCompletion,
            item.complete && styles.stepButtonComplete,
          )}
        >
          <div />
        </div>
        {/* Render the link between steps */}
        {index < items.length - 1 && (
          <div
            className={classNames(
              styles.stepLink,
              firstIncomplete > index && styles.stepLinkComplete,
            )}
          />
        )}
      </div>
      <div>{item.label}</div>
    </>
  );

  const button = (item: StatusItem, index: number) => {
    if (item.hide) {
      return null;
    }

    if (item.to) {
      return (
        <LinkButton
          key={index}
          className={classNames(styles.stepItemContainer, item.className)}
          to={item.to}
          variant="minimal"
        >
          {renderItemContent(item, index)}
        </LinkButton>
      );
    }

    return (
      <Button
        key={index}
        className={classNames(styles.stepItemContainer, item.className)}
        onClick={item.onClick}
        variant="minimal"
      >
        {renderItemContent(item, index)}
      </Button>
    );
  };

  return (
    <div className={styles.container}>
      {items.map((item, index) => button(item, index))}
    </div>
  );
};
